import { render, staticRenderFns } from "./recall.vue?vue&type=template&id=7a70bc19&scoped=true&"
import script from "./recall.vue?vue&type=script&lang=js&"
export * from "./recall.vue?vue&type=script&lang=js&"
import style0 from "./recall.vue?vue&type=style&index=0&id=7a70bc19&lang=scss&scoped=true&"
import style1 from "./recall.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a70bc19",
  null
  
)

export default component.exports